import { Subscription } from "rxjs"
import { OnDestroy } from "@angular/core"

export class EduComponent implements OnDestroy {
    subscriptions: Subscription[] = []

    addSub(subscription: Subscription) {
        this.subscriptions.push(subscription)
        return subscription
    }

    clearSubs() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }

    ngOnDestroy() {
        this.clearSubs()
    }
}
